import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import useAPI from '../../../../../api';
import DialogContent from './DialogContent';
import Dialog from '../../../../../Components/Dialog';

const CtaDialog = function CtaDialog({
  open = null,
  close = () => {},
  onSubmit = () => {},
}) {
  const API = useAPI();
  const methods = useForm();
  const [tags, setTags] = useState([]);
  const [existingCta, setExistingCta] = useState([]);

  useEffect(() => {
    if (open)
      API.getAllTags(
        { silent: true },
        (response) => {
          setTags(response);
        },
        () => {
          setTags([]);
        }
      );
  }, [open]);

  useEffect(() => {
    if (open)
      API.getCallToActions(
        { silent: true },
        (response) => {
          const mappedResponse = response.map((cta) => ({
            ...cta,
            ctaId: cta?.id,
          }));
          setExistingCta(mappedResponse);
          if (typeof open === 'string') {
            methods?.reset(mappedResponse.find(({ ctaId }) => ctaId === open));
          }
        },
        () => {
          setExistingCta([]);
        }
      );
  }, [open]);

  return (
    <Dialog
      id="cta-dialog"
      open={open}
      onClose={close}
      fullWidth
      width="xs"
      title="EDIT_CTA"
      form
      onSubmit={(data) => {
        onSubmit(data);
      }}
      styles={{
        content: {
          flexDirection: 'column',
          padding: 0,
          overflow: 'hidden',
        },
      }}
    >
      <DialogContent
        tags={tags}
        existingCta={existingCta}
        inEdit={
          typeof open === 'string' &&
          existingCta?.find(({ ctaId }) => ctaId === open)
        }
        resetValues={() => {
          methods?.reset({
            ctaId: null,
            text: null,
            responseText: null,
            tagId: null,
          });
        }}
      />
    </Dialog>
  );
};

CtaDialog.propTypes = {
  open: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  close: PropTypes.func,
  onSubmit: PropTypes.func,
};
export default CtaDialog;
